var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_17326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57994 9.79833L1.57857 9.79614C1.29856 9.3505 1.12842 8.70411 1.12842 8.00291C1.12842 7.30238 1.29827 6.65311 1.57952 6.20233C3.30581 3.45083 5.71446 2 8.13221 2C10.5503 2 12.9586 3.45118 14.6769 6.20167L14.6783 6.20386C14.9583 6.6495 15.1284 7.29589 15.1284 7.99709C15.1284 8.69796 14.9584 9.34753 14.6769 9.79833C12.9586 12.5488 10.5503 14 8.13221 14C5.70606 14 3.29792 12.5483 1.57994 9.79833Z",
    stroke: "#0C5EFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12842 15L15.1284 1",
    stroke: "#0C5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54592 6.61119C9.53769 6.60266 9.52937 6.5942 9.52096 6.58579C8.73991 5.80474 7.47358 5.80474 6.69253 6.58579C5.91153 7.36679 5.91149 8.63303 6.69241 9.41409L9.52061 6.58588L9.54592 6.61119ZM9.53995 9.39497L9.50171 9.43321C9.50816 9.42693 9.51458 9.4206 9.52096 9.41421C9.52734 9.40783 9.53368 9.40141 9.53995 9.39497Z",
    fill: "#0C5EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_17326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.128418)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosedIcon);
export default __webpack_public_path__ + "static/media/eye-closed-icon.4cc8c042b32090f75c7035c82dc0e351.svg";
export { ForwardRef as ReactComponent };